import styled, { keyframes } from 'styled-components';

const WaveAnimation = keyframes`
    0% {
      transform: rotateZ(0deg) translate3d(0, 5%, 0) rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg) translate3d(0, 5%, 0) rotateZ(-360deg);
    }
`;

const WavesContainerStyled = styled.div`
  width: 100%;
  height: 317px;
  position: relative;
  overflow: hidden;
  margin-bottom: -180px;
`;

const LayerOneStyled = styled.div`
  height: 100%;
  svg {
    position: absolute;
    bottom: -60px;
    margin-left: -300px;
    width: 2500px;
    animation: ${WaveAnimation} 4s 0.1s infinite linear;
  }
`;
const LayerTwoStyled = styled(LayerOneStyled)`
  svg {
    opacity: 0.6;
    bottom: -80px;
    margin-left: -150px;
    animation: ${WaveAnimation} 4.5s 0.3s infinite linear;
  }
`;
const LayerThreeStyled = styled(LayerTwoStyled)`
  svg {
    bottom: -70px;
    margin-left: -520px;
    animation: ${WaveAnimation} 5s 0.5s infinite linear;
  }
`;

export {
  WavesContainerStyled,
  LayerOneStyled,
  LayerTwoStyled,
  LayerThreeStyled,
};
